import { AddCircleOutline, CheckCircleRounded } from '@mui/icons-material';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { SupplierItemWithAssortmentTags } from '@retail/products/types';
import { EditButtonIcon, TrashIcon } from '@shared/custom-icons';
import { AssortmentTagWithSupplierItemId } from './AssortmentTagTableContent';
import { AssortmentTag } from '@retail/my-assortment/types';
import { useProductsTFunction } from '@retail/products/i18n';
import { getLLDate } from '@retail/utils';

interface Props {
  currentTag: AssortmentTag;
  supplierItemTags: SupplierItemWithAssortmentTags;
  hoveredCell?: AssortmentTagWithSupplierItemId;
  setAssortmentTagToAdd?: (tag: AssortmentTagWithSupplierItemId) => void;
  setAssortmentTagToEdit?: (tag: AssortmentTagWithSupplierItemId) => void;
  setItemAssortmentTagToDelete?: (tag: AssortmentTag, mgSupplierItemId: number) => void;
}

export function AssortmentTagTableCell({
  currentTag,
  supplierItemTags,
  hoveredCell,
  setAssortmentTagToAdd,
  setAssortmentTagToEdit,
  setItemAssortmentTagToDelete,
}: Props) {
  const t = useProductsTFunction();

  const currentPriorityTag = supplierItemTags.tags?.find((tag) => tag.tagId === currentTag.id);

  if (currentPriorityTag) {
    return (
      <Stack position="relative">
        {hoveredCell?.assortmentTag.id === currentTag.id &&
          hoveredCell.mgSupplierItemId === supplierItemTags.mgSupplierItemId && (
            <Stack gap={0.5} flexDirection="row" position="absolute" top={0} right={0}>
              <IconButton
                sx={{ padding: 0 }}
                onClick={() =>
                  setAssortmentTagToEdit?.({
                    assortmentTag: currentTag,
                    mgSupplierItemId: supplierItemTags.mgSupplierItemId,
                  })
                }
              >
                <EditButtonIcon fontSize="small" />
              </IconButton>
              <IconButton
                sx={{ padding: 0.5 }}
                onClick={() =>
                  setItemAssortmentTagToDelete?.(currentTag, supplierItemTags.mgSupplierItemId)
                }
              >
                <TrashIcon fontSize="small" />
              </IconButton>
            </Stack>
          )}
        <Stack alignItems="center" justifyContent="center" gap={0.5} p={2}>
          <CheckCircleRounded fontSize="small" sx={{ color: 'success.main' }} />
          <Stack alignItems="center">
            <Typography variant="body3" color="text.secondary">
              {getLLDate(currentPriorityTag.validFrom)}
            </Typography>
            <Typography variant="body3" color="text.secondary">
              {getLLDate(currentPriorityTag.validTo) ?? '-'}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    );
  }
  return (
    <Stack flexDirection="row" alignItems="center" justifyContent="center">
      {hoveredCell?.assortmentTag.id === currentTag.id &&
      hoveredCell.mgSupplierItemId === supplierItemTags.mgSupplierItemId ? (
        <Tooltip
          title={
            <Stack gap={1}>
              <Typography variant="body2">
                {t('products.mgItem.addItemsToAssortment.addToAssortmentTag')}
              </Typography>
              <Typography variant="body2">
                {!supplierItemTags.inAssortment && t('products.mgItem.mustBeInAssortment')}
              </Typography>
            </Stack>
          }
          arrow
        >
          <div>
            <IconButton
              sx={{ padding: 0 }}
              disabled={!supplierItemTags.inAssortment}
              onClick={() =>
                setAssortmentTagToAdd?.({
                  assortmentTag: currentTag,
                  mgSupplierItemId: supplierItemTags.mgSupplierItemId,
                })
              }
            >
              <AddCircleOutline
                fontSize="small"
                sx={{ color: supplierItemTags.inAssortment ? 'success.main' : undefined }}
              />
            </IconButton>
          </div>
        </Tooltip>
      ) : (
        '-'
      )}
    </Stack>
  );
}
